import { css } from 'aphrodite';
import { observer } from 'mobx-react';
import * as React from 'react';
import { IUser, IUserReference } from '../../../../../extViewmodels';
import { getDisplayName } from '../../../../../models/NameUtils';
import { UserAutocomplete } from '../../../../../web/components/UserAutocomplete';
import { LeadRuleViewModel } from '../../../../viewModels/leadrules';
import { styleSheet } from '../../styles';
import { SelectedItem } from './SelectedItem';

interface IProps {
	leadRule: LeadRuleViewModel;
}

export const IndividualPicker: React.FC<IProps> = observer(({ leadRule }) => {
	const users: IUserReference[] = leadRule?.users ?? [];

	const handleAdd = (user: IUser | null) => {
		if (!user?.id || users.some(item => item.id === user.id)) {
			return;
		}
		const { email, firstName, id, lastName, primaryEmail, profilePic } = user;
		leadRule?.setUsers(users.concat({ email, firstName, id, lastName, primaryEmail, profilePic }));
	};

	return (
		<div className={css(styleSheet.radioContent)}>
			<UserAutocomplete ariaLabel='Search Employees' onChange={handleAdd} placeholder='Search Employees' value={null} />
			{users.map(user => (
				<SelectedItem
					key={user.id}
					name={getDisplayName(user)}
					onRemove={() => leadRule?.setUsers(users.filter(item => item.id !== user.id))}
				/>
			))}
		</div>
	);
});
